import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SplashScreenStateService } from '../../services/splash-screen-state.service';
import { GridModule } from '@coreui/angular-pro';
@Component({
  selector: 'app-splash-screen',
  imports: [CommonModule, MatIconModule, GridModule],
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss',
  standalone: true,
})
export class SplashScreenComponent implements OnInit {
  // The screen starts with the maximum opacity
  public opacityChange = 1;
  public windowWidth: string = '0px';
  public splashTransition: string = '';
  // First access the splash is visible
  public showSplash = true;
  readonly ANIMATION_DURATION = 1;

  constructor(private splashScreenState: SplashScreenStateService) {
    console.log('splashScreen: constructor');
  }

  ngOnInit(): void {
    // Maximum timeout - hide splash screen after 15 seconds no matter what
    const maxTimeout = setTimeout(() => {
      if (this.showSplash) {
        console.warn('Splash screen maximum timeout (15s) reached, forcing hide');
        this.hideSplash();
      }
    }, 15000);

    // Listen for resolver or component to stop the splash screen
    this.splashScreenState.subscribe((state: any) => {
      console.log('splashScreenState.subscribe: ' + state);
      if (state === false) {
        this.hideSplash();
        clearTimeout(maxTimeout);
      } else if (state === 'stopFast') {
        this.hideSplash(10);
        clearTimeout(maxTimeout);
      }
    });
  }

  hideSplash(duration = 500) {
    // hide it only if it is visible
    if (this.showSplash) {
      this.windowWidth = '-' + window.innerWidth + 'px';
      setTimeout(() => {
        this.showSplash = false;
      }, duration);
    }
  }
}
